import React, { useMemo, useState } from "react";

import styled from "styled-components";

import Dropdown from "components/atoms/Dropdown";
import Icon from "components/atoms/Icon";
import Tooltip from "components/atoms/Tooltip";
import { FigureModalSource } from "components/organisms/manuscript/visual/figure-modal-context";
import * as toolbarCommands from "components/organisms/manuscript/visual/toolbar/commands";

const FigureMenuPopover = styled.div`
    padding: 6px;
    border: 1px solid #d8e1ec;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.12);
`;

const FigureMenuList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

const FigureMenuItem = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    min-width: 180px;
    height: 32px;
    padding: 0 10px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: #42576b;
    font-size: 12px;
    font-weight: 600;
    text-align: left;
    cursor: pointer;

    &:hover {
        background: #eef3f8;
    }
`;

function ManuscriptFigureDropdown({ Button, disabled, iconColor, onOpenFigureModal, runEditorCommand }) {
    const [open, setOpen] = useState(false);

    const options = useMemo(
        () => [
            {
                id: "upload",
                label: "컴퓨터에서 업로드",
                icon: "upload",
                source: FigureModalSource.FILE_UPLOAD,
            },
            {
                id: "project",
                label: "프로젝트 파일에서 선택",
                icon: "folder",
                source: FigureModalSource.FILE_TREE,
            },
            {
                id: "url",
                label: "URL에서 가져오기",
                icon: "link",
                source: FigureModalSource.FROM_URL,
            },
        ],
        [],
    );

    const handleSelect = (source) => {
        setOpen(false);
        onOpenFigureModal?.(source);
    };

    return (
        <Tooltip message="그림">
            <Dropdown
                open={open}
                onOpenChange={setOpen}
                placement="bottom-start"
                offset={6}
                anchor={
                    <Button
                        type="button"
                        onMouseDown={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                        }}
                        onClick={(event) => {
                            if (disabled) {
                                event.preventDefault();
                                return;
                            }

                            if (event.altKey && !open) {
                                runEditorCommand(toolbarCommands.insertFigure);
                                return;
                            }

                            setOpen((prev) => !prev);
                        }}
                        disabled={disabled}
                        aria-label="그림 삽입"
                    >
                        <Icon name={"imageBlock"} size={"12px"} color={iconColor} />
                    </Button>
                }
                contentMinWidth="208px"
            >
                <FigureMenuPopover>
                    <FigureMenuList role="menu">
                        {options.map((option) => (
                            <FigureMenuItem
                                key={option.id}
                                type="button"
                                role="menuitem"
                                onClick={() => handleSelect(option.source)}
                            >
                                <Icon name={option.icon} size={"12px"} color={"#42576b"} />
                                <span>{option.label}</span>
                            </FigureMenuItem>
                        ))}
                    </FigureMenuList>
                </FigureMenuPopover>
            </Dropdown>
        </Tooltip>
    );
}

export default React.memo(ManuscriptFigureDropdown);
